import cx from 'classnames';

import './button.styles.scss';

const Button = ({ children, disabled, className, ...otherProps }) => {
  return (
    <button
      className={cx('button-container', className, { disabled })}
      disabled={disabled}
      {...otherProps}
    >
      {children}
    </button>
  );
};

export default Button;
